export default {
	home: '/',
	verify: '/verify',
	auth: {
		login: '/auth/login/',
		register: '/auth/register/',
	},
};
